export const userConstants = {
  odcInternalUserId: '5b1dd496-f7a4-4011-b4e2-987a41c131f4',
  defaultInternalOrgId: 'default-internal'
};

/**
 * Canonical BCP 47 tags the product ships UI and mail catalogs for.
 * Persistence form (`User.preferredLanguage`); Neutron mail locale folders use the same tags (`pt-BR`).
 */
export const SUPPORTED_LANGUAGE_TAGS = [
  'en',
  'es-MX',
  'fr-CA',
  'pt-BR',
  'zh',
  'zh-TW',
  'ja',
  'ko',
  'id',
  'th',
  'vi'
] as const;

export type SupportedLanguageTag = (typeof SUPPORTED_LANGUAGE_TAGS)[number];
